import React from "react";
import { Button } from "components/generic/kit";
import { Input, Formik } from "components/generic/form/formik";
import {
  Description,
  Title,
  Row,
  Label,
  ErrorBox
} from "components/generic/form/service";
import { NarrowBody } from "components/generic/layout";
import { UnsignedLayout } from "components/common/auth";

export default ({ validationSchema, onSubmit, resetPasswordApi, errors }) => (
  <UnsignedLayout>
    <NarrowBody>
      <Formik
        initialValues={{
          email: ""
        }}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
        errors={errors.field}
      >
        {props => (
          <div>
            {!!errors.nonField.length && <ErrorBox errors={errors.nonField} />}
            <Title>Forgot password?</Title>
            <Description>
              Please enter your email below. We will send you an email which
              will allow you to set a new password.
            </Description>
            <form onSubmit={props.handleSubmit}>
              <Row>
                <Label title="Email">
                  <Input name="email" placeholder="Your email" type="email" />
                </Label>
              </Row>

              <div className="mt3">
                <Button type="submit" disabled={resetPasswordApi.isFetching}>
                  Send me the email
                </Button>
              </div>
            </form>
          </div>
        )}
      </Formik>
    </NarrowBody>
  </UnsignedLayout>
);



// WEBPACK FOOTER //
// ./src/components/pages/Auth/ResetPass/View.js